import React, { useState, useEffect } from "react";
import { getMeals, addMeal, deleteMeal, updateMeal, clearMeals } from "./api";
import MealForm from "./components/MealForm";
import MealList from "./components/MealList";
import ChatBot from "./components/ChatBot";
import "./App.css";

const DEFAULT_MEALS = [
    { name: "Pizza", calories: 503, carbs: 76, protein: 32, fats: 56, fiber: 7 },
    { name: "Banana", calories: 90, carbs: 20, protein: 1, fats: 0, fiber: 3 },
];

const generateUUID = () =>
    "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });

// A browser gets a session on its first visit; module-level so React
// StrictMode's double effects can't seed the example meals twice.
let isNewSession = false;
let seedPromise = null;

const ensureSession = () => {
    let id = localStorage.getItem("session_id");
    if (!id) {
        id = generateUUID();
        localStorage.setItem("session_id", id);
        isNewSession = true;
    }
    return id;
};

const seedDefaultMeals = async () => {
    try {
        for (const meal of DEFAULT_MEALS) await addMeal(meal);
    } catch (e) {
        // Seeding is best-effort; the app works without it.
    }
};

function App() {
    useState(ensureSession);
    const [meals, setMeals] = useState([]);
    const [editingMeal, setEditingMeal] = useState(null);

    const fetchMeals = async () => {
        const data = await getMeals();
        setMeals(data);
    };

    useEffect(() => {
        (async () => {
            if (isNewSession) {
                isNewSession = false;
                seedPromise = seedDefaultMeals();
            }
            await seedPromise;
            fetchMeals();
        })();
    }, []);

    const handleAddMeal = async (newMeal) => {
        await addMeal(newMeal);
        fetchMeals();
    };

    const handleDeleteMeal = async (id) => {
        await deleteMeal(id);
        fetchMeals();
    };

    const handleUpdateMeal = async (id, updatedMealData) => {
        await updateMeal(id, updatedMealData);
        setEditingMeal(null);
        fetchMeals();
    };

    const handleClearMeals = async () => {
        if (!window.confirm("Delete all meals?")) return;
        await clearMeals();
        fetchMeals();
    };

    return (
        <div className="app-container">
            <h1>James' Calorie Tracker</h1>

            <MealForm
                onAdd={handleAddMeal}
                editingMeal={editingMeal}
                onUpdate={handleUpdateMeal}
            />

            <div className="main-columns">
                <ChatBot
                    onMealAdded={fetchMeals}
                />

                <div className="meals-column">
                    <MealList
                        meals={meals}
                        onDelete={handleDeleteMeal}
                        onEdit={(meal) => setEditingMeal(meal)}
                        onClearAll={handleClearMeals}
                    />
                </div>
            </div>
        </div>
    );
}

export default App;
